import { useState, useRef, useEffect } from "react";
import "@/App.css";
import {
  Heart,
  Copy,
  Share2,
  RotateCcw,
  Clock,
  Images,
  X,
  ChevronLeft,
  ChevronRight,
  Sparkles,
  Volume2,
  VolumeX,
  Camera,
  BookHeart,
  Mail,
} from "lucide-react";
import { Toaster, toast } from "sonner";

const RECIPIENT = "Seher";

// İlk sevgili olduğumuz tarih
const START_DATE = new Date("2025-08-28T00:00:00");

const PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_love-me-game-29/artifacts/ewrbl6qm_WhatsApp%20Image%202026-04-11%20at%2021.50.15.jpeg",
    title: "yol arkadaşım",
    quote:
      "Hangi yola çıksam, sen yanımda olduğun sürece varış noktası önemsiz. Yolun adı sadece 'biz'.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_love-me-game-29/artifacts/jeo2zhks_WhatsApp%20Image%202026-04-13%20at%2020.59.09.jpeg",
    title: "yanağına bir öpücük",
    quote:
      "O minik öpücük, en sessiz anlarımızın en yüksek mutluluk sesi. Hâlâ aynı yerden öpmek isterim seni.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_love-me-game-29/artifacts/y42fill5_WhatsApp%20Image%202026-04-25%20at%2020.30.01.jpeg",
    title: "küçük kaçamaklarımız",
    quote:
      "Bizim kaçamaklarımız hayatın en saf, en tatlı isyanları. Seninle gizli her dakika dünyaya bedel.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_love-me-game-29/artifacts/vg2awm57_WhatsApp%20Image%202026-04-26%20at%2023.14.43.jpeg",
    title: "en tatlı hali",
    quote:
      "En tatlı halin, beni hep aynı anda gülümsetip kalbimi titretiyor. Sen — bütün hallerinle — benim en güzelim.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_love-me-game-29/artifacts/q8qoy0pk_WhatsApp%20Image%202026-05-01%20at%2018.16.55.jpeg",
    title: "ışık hep seninle güzel",
    quote:
      "Işık nereye düşse seni buluyor — sanki güneş seni öğrenmiş. Sen olduğun her yer aydınlanıyor.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_love-me-game-29/artifacts/oc4iscpo_WhatsApp%20Image%202026-05-03%20at%2018.01.10.jpeg",
    title: "o gülüş",
    quote:
      "Senin gülüşün, en uzun günleri bile pırıl pırıl ediyor. Bir bakışın bir günümü çiçeğe çeviriyor, Seher.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_love-me-game-29/artifacts/ced5ik8g_WhatsApp%20Image%202026-05-03%20at%2018.01.41.jpeg",
    title: "yan yana",
    quote:
      "Omzumda başın olduğu her kare, hayatımın en güzel sayfası. Sen yanımdayken zaman bile yavaşlıyor.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_love-me-game-29/artifacts/xou3bw2a_WhatsApp%20Image%202026-05-03%20at%2018.02.39.jpeg",
    title: "deniz ve sen",
    quote:
      "Deniz, seni görünce mavisini sana vermiş gibi. Bakışın ufku, gülüşün güneşi taşıyor içinde.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_love-me-game-29/artifacts/lj37i316_jj.jpeg",
    title: "küçük biz",
    quote:
      "Belki çocukken başladık birbirimizi sevmeye, sadece henüz tanışmamıştık. Kalbim seni hep biliyormuş.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_love-me-game-29/artifacts/owuirnq6_WhatsApp%20Image%202026-05-03%20at%2018.07.07.jpeg",
    title: "minik dünyamız",
    quote:
      "İki masa, iki fırça, bir kahve — ama en güzeli senin gülüşündü. Seninle her köşe, dünyanın en sıcak yeri.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_love-me-game-29/artifacts/tb9urs1b_WhatsApp%20Image%202026-05-03%20at%20%C4%B1oj%C4%B1.jpeg",
    title: "Şimşek & Sally",
    quote:
      "Sen pembe Sally, ben senin Şimşek'in. Yarış bitse de yol seninse ben yine yanındayım.",
  },
];

function diffParts(start, now) {
  let months =
    (now.getFullYear() - start.getFullYear()) * 12 +
    (now.getMonth() - start.getMonth());
  const anchor = new Date(start);
  anchor.setMonth(anchor.getMonth() + months);
  if (now < anchor) {
    months -= 1;
    anchor.setMonth(anchor.getMonth() - 1);
  }
  let rem = now - anchor;
  const dayMs = 86400000;
  const totalDaysAfterMonths = Math.floor(rem / dayMs);
  const weeks = Math.floor(totalDaysAfterMonths / 7);
  const days = totalDaysAfterMonths - weeks * 7;
  rem -= totalDaysAfterMonths * dayMs;
  const hours = Math.floor(rem / 3600000);
  rem -= hours * 3600000;
  const minutes = Math.floor(rem / 60000);
  rem -= minutes * 60000;
  const seconds = Math.floor(rem / 1000);
  const totalDays = Math.floor((now - start) / dayMs);
  return { months, weeks, days, hours, minutes, seconds, totalDays };
}

const LOVE_MESSAGE = `Seni seviyorum aşkım.
Gülüşün günümün en güzel yeri,
sesin en sevdiğim melodi.
Elimi tuttuğun her an,
dünya bir parça daha güzel.
Sonsuza kadar seninim, Seher.`;

const QUIZ_QUESTIONS = [
  {
    id: 1,
    q: "İlk fotoğrafımız nerede çekildi?",
    options: [
      { key: "A", text: "Adalar" },
      { key: "B", text: "Lens" },
      { key: "C", text: "Metro" },
    ],
    correct: "B",
    feedback: "Tabii ki Lens — o an hâlâ aklımda 💕",
  },
  {
    id: 2,
    q: "İlk mesajı kim attı?",
    options: [
      { key: "A", text: "Sir Enes" },
      { key: "B", text: "Seherişko" },
      { key: "C", text: "Ben bilmezük" },
    ],
    correct: "B",
    feedback: "O ilk mesaj her şeyin başlangıcıydı ❤️",
  },
  {
    id: 3,
    q: "Sonsuza kadar benimle olur musun?",
    options: [
      { key: "A", text: "Evet ❤️" },
      { key: "B", text: "Tabii ki 💕" },
      { key: "C", text: "Sonsuza kadar 💍" },
    ],
    correct: "ANY",
    feedback: "Sen olduğun her cevap doğru cevap 💗",
  },
];

const QUIZ_POEM = `Bir baktım, gözlerin günümün rengi,
sesin kalbimin en yumuşak yeri.
Seninle her saniye sonsuza yakın,
her sessizlik tatlı bir şarkıya benziyor.
Seni seçtim — seçmeye devam edeceğim,
yarın da, öbür gün de, sonsuza kadar.`;

// ============== LOVE RPG ==============
const LOVE_RPG_SCENES = [
  {
    id: 1,
    title: "Lens'teki bir günümüz",
    text: "Lens'te seninle yine bir aradayız. Gözlerin her zamanki gibi bana gülüyor, ben yine bakmaya doyamıyorum. Tam sana bir şey söyleyecekken:",
    choices: [
      { text: "Saçından bir tutamı kulak ardına koyuyorum 💕", love: 8 },
      { text: "Önce uzaktan izleyip gülümsüyorum", love: 5 },
      { text: "Elini tutup 'iyi ki varsın' diyorum ❤️", love: 10 },
    ],
  },
  {
    id: 2,
    title: "İlk mesaj",
    text: "Telefonum titrediğinde, ekranda senin adını gördüm. Kalbim koştu. Cevabımı:",
    choices: [
      { text: "Hemen yazdım, beklemek istemedim 💌", love: 9 },
      { text: "Sakin durup biraz sonra cevapladım", love: 4 },
      { text: "Bütün gece düşündüm, en güzel cümleyi seçtim ✨", love: 7 },
    ],
  },
  {
    id: 3,
    title: "İlk randevu",
    text: "İlk gerçek randevumuzdayız. Karşımdasın. Sessizliği bozmak isterken:",
    choices: [
      { text: "Komik bir anımı anlatıyorum, gülüşünü görmek için 😄", love: 8 },
      { text: "Gözlerinin içine bakıp 'çok güzelsin' diyorum 🌹", love: 10 },
      { text: "Sessizce elini tutuyorum ✋", love: 9 },
    ],
  },
  {
    id: 4,
    title: "Küçük bir kırgınlık",
    text: "Küçük bir tartışma. Sesin titriyor, ben içten içe yıkılıyorum. Hata bende olmasa da:",
    choices: [
      { text: "İlk özür dileyen ben oluyorum 💗", love: 12 },
      { text: "Susuyorum, anlayışla bekliyorum", love: 5 },
      { text: "Haklıyım diye direniyorum", love: -8 },
    ],
  },
  {
    id: 5,
    title: "Sürpriz hediye",
    text: "Sana bir sürpriz hazırlamak istiyorum. Aklımdaki seçenekler:",
    choices: [
      { text: "Sevdiğin kokuyu özenle seçiyorum 🌸", love: 6 },
      { text: "Senin için bir şarkı ararım, ezbere öğrenirim 🎵", love: 10 },
      { text: "Gizli bir mektup yazıyorum, kalbimden kalbine ✉️", love: 12 },
    ],
  },
  {
    id: 6,
    title: "Sahilde gün batımı",
    text: "Sahildeyiz. Güneş batıyor, sen bana yaslandın. Tam o an:",
    choices: [
      { text: "Saçlarına bir öpücük kondurup hiç konuşmuyorum 💋", love: 11 },
      { text: "'Seninle her gün böyle olsun' diye fısıldıyorum", love: 10 },
      { text: "Telefonumla bu anı sessizce kaydediyorum 📷", love: 6 },
    ],
  },
  {
    id: 7,
    title: "Hasta gecesi",
    text: "Hastasın. Sesin yorgun, gözlerin yarı kapalı. Yanına gittiğimde:",
    choices: [
      { text: "Çorba yapıp başucunda nöbet tutuyorum 🍲", love: 10 },
      { text: "Sabaha kadar elini tutup hikâye anlatıyorum 📖", love: 12 },
      { text: "Sessizce alnına bir öpücük bırakıyorum, dinlensin diye", love: 9 },
    ],
  },
  {
    id: 8,
    title: "Aileyle tanışma",
    text: "Aileni ilk kez bu kadar yakından göreceğim. Gözlerine bakıp:",
    choices: [
      { text: "'Sen yanımdaysan korkmuyorum' diyorum ✨", love: 10 },
      { text: "Heyecanlıyım ama elini sıkı tutuyorum 🤝", love: 7 },
      { text: "İçimden 'ne olursa olsun seninleyim' diyorum", love: 9 },
    ],
  },
  {
    id: 9,
    title: "Geleceğin hayali",
    text: "Geleceği konuşuyoruz. Gözlerin parıldıyor. Hayalim:",
    choices: [
      { text: "Küçük bir ev, kahve kokusu, sen ve ben ☕", love: 10 },
      { text: "Birlikte çıkacağımız uzun bir yol 🛣️", love: 9 },
      { text: "Adın yanımda yazılı bir kapı 🚪💕", love: 12 },
    ],
  },
  {
    id: 10,
    title: "Sonsuza dair",
    text: "Şu an. Karşımdasın. Sana son bir şey söylemek istesem, sadece:",
    choices: [
      { text: "Seni seçtim, seçmeye devam edeceğim 💍", love: 15 },
      { text: "Sen olmadan dünya bir parça eksik 🌎", love: 12 },
      { text: "Sonsuza kadar — başka söze gerek yok ∞", love: 14 },
    ],
  },
];

const SECRET_MESSAGE = `Bunu sadece sen görebilirsin, Seher.
Seni seviyorum — cümleyle anlatılmaz,
kalpten kalbe sessizce geçer.
Senin olmaktan başka bir şey bilmiyorum.
Ve bu satırlar, kalbimin gizli odası.`;

const FINAL_TEXT =
  "Aslında hiçbir şey bozulmadı… sadece seni daha çok sevdim 💖";

const Floater = ({ delay, left, size, duration }) => (
  <span
    className="heart-floater"
    style={{
      left: `${left}%`,
      animationDelay: `${delay}s`,
      animationDuration: `${duration}s`,
      fontSize: `${size}px`,
    }}
    aria-hidden="true"
  >
    <Heart fill="#e85a7a" strokeWidth={0} />
  </span>
);

// ─── Hello Kitty SVG (sade, sevimli) ───
const HelloKitty = ({ size = 64 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* sol kulak */}
    <path d="M22 32 L14 14 L34 26 Z" fill="#fff" stroke="#3a1d26" strokeWidth="2" strokeLinejoin="round" />
    {/* sağ kulak */}
    <path d="M78 32 L86 14 L66 26 Z" fill="#fff" stroke="#3a1d26" strokeWidth="2" strokeLinejoin="round" />
    {/* yüz */}
    <ellipse cx="50" cy="58" rx="34" ry="30" fill="#fff" stroke="#3a1d26" strokeWidth="2.5" />
    {/* gözler */}
    <ellipse cx="38" cy="58" rx="3" ry="4.5" fill="#3a1d26" />
    <ellipse cx="62" cy="58" rx="3" ry="4.5" fill="#3a1d26" />
    {/* burun */}
    <ellipse cx="50" cy="65" rx="3.5" ry="2.5" fill="#f4c430" />
    {/* sol bıyıklar */}
    <path d="M30 60 L18 56" stroke="#3a1d26" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M30 64 L18 64" stroke="#3a1d26" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M30 68 L18 72" stroke="#3a1d26" strokeWidth="1.6" strokeLinecap="round" />
    {/* sağ bıyıklar */}
    <path d="M70 60 L82 56" stroke="#3a1d26" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M70 64 L82 64" stroke="#3a1d26" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M70 68 L82 72" stroke="#3a1d26" strokeWidth="1.6" strokeLinecap="round" />
    {/* fiyonk (sağ kulakta) */}
    <circle cx="68" cy="22" r="6" fill="#e85a7a" stroke="#b8274a" strokeWidth="1.2" />
    <path d="M62 22 L52 16 L52 28 Z" fill="#e85a7a" stroke="#b8274a" strokeWidth="1.2" strokeLinejoin="round" />
    <path d="M74 22 L84 16 L84 28 Z" fill="#e85a7a" stroke="#b8274a" strokeWidth="1.2" strokeLinejoin="round" />
    <circle cx="68" cy="22" r="1.5" fill="#fff5f7" />
  </svg>
);

// ─── Minik çiçek SVG ───
const Blossom = ({ size = 24, color = "#f7c8d1", center = "#fde2a8" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {[0, 72, 144, 216, 288].map((deg) => (
      <ellipse
        key={deg}
        cx="16"
        cy="9"
        rx="4.5"
        ry="6.5"
        fill={color}
        transform={`rotate(${deg} 16 16)`}
        opacity="0.95"
      />
    ))}
    <circle cx="16" cy="16" r="2.4" fill={center} />
  </svg>
);

const LovePage = () => {
  const [answered, setAnswered] = useState(false);
  const [noPos, setNoPos] = useState({ x: 0, y: 0 });
  const [noClicks, setNoClicks] = useState(0);
  const [showTimer, setShowTimer] = useState(false);
  const [lightboxIdx, setLightboxIdx] = useState(null);
  const [now, setNow] = useState(() => new Date());
  // Quiz state
  const [quizStage, setQuizStage] = useState("closed"); // closed | intro | 0 | 1 | 2 | finale
  const [quizFeedback, setQuizFeedback] = useState(null); // { ok, text }
  const [shake, setShake] = useState(false);
  const [typedPoem, setTypedPoem] = useState("");
  const [musicOn, setMusicOn] = useState(true);
  // Fotiklerr (extra posters) toggle
  const [showExtras, setShowExtras] = useState(false);
  // Love RPG state
  const [rpgStage, setRpgStage] = useState("closed"); // closed | intro | 0..9 | glitch | final
  const [loveMeter, setLoveMeter] = useState(50);
  const [secretOpen, setSecretOpen] = useState(false);
  const [typedSecret, setTypedSecret] = useState("");
  const [animatedLove, setAnimatedLove] = useState(0);
  const containerRef = useRef(null);

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const parts = diffParts(START_DATE, now);

  const NO_TEASES = [
    "Emin misin? 🙈",
    "Bir daha dene...",
    "Orada değilim!",
    "Beni yakalayamazsın",
    "Hadi ama, Seher...",
    "Kalbim kırıldı 💔",
    "Gerçekten mi?",
    "Şaka yapıyorsun değil mi?",
  ];

  const moveNoButton = () => {
    const max = 220;
    const x = (Math.random() - 0.5) * max * 2;
    const y = (Math.random() - 0.5) * 120;
    setNoPos({ x, y });
    setNoClicks((c) => c + 1);
  };

  const handleYes = () => {
    setAnswered(true);
  };

  const reset = () => {
    setAnswered(false);
    setNoPos({ x: 0, y: 0 });
    setNoClicks(0);
  };

  const shareWhatsApp = () => {
    const text = encodeURIComponent(
      `Seher, beni seviyor musun? 💕 ${window.location.href}`
    );
    window.open(`https://wa.me/?text=${text}`, "_blank");
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      toast.success("Bağlantı kopyalandı", {
        description: "Sevdiğinle paylaşabilirsin",
      });
    } catch {
      toast.error("Kopyalanamadı, tekrar dener misin?");
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Beni Seviyor Musun?",
          text: `Seher, beni seviyor musun? 💕`,
          url: window.location.href,
        });
      } catch {
        /* user cancelled */
      }
    } else {
      copyLink();
    }
  };

  const openPhoto = (i) => setLightboxIdx(i);
  const closePhoto = () => setLightboxIdx(null);
  const nextPhoto = (e) => {
    e?.stopPropagation();
    setLightboxIdx((i) => (i === null ? 0 : (i + 1) % PHOTOS.length));
  };
  const prevPhoto = (e) => {
    e?.stopPropagation();
    setLightboxIdx((i) =>
      i === null ? 0 : (i - 1 + PHOTOS.length) % PHOTOS.length
    );
  };

  useEffect(() => {
    if (lightboxIdx === null) return;
    const onKey = (e) => {
      if (e.key === "Escape") closePhoto();
      else if (e.key === "ArrowRight") nextPhoto();
      else if (e.key === "ArrowLeft") prevPhoto();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [lightboxIdx]);

  // ---------- QUIZ ----------
  const openQuiz = () => {
    setQuizStage("intro");
    setQuizFeedback(null);
    setTypedPoem("");
  };
  const closeQuiz = () => {
    setQuizStage("closed");
    setQuizFeedback(null);
    setShake(false);
    setTypedPoem("");
  };
  const startQuiz = () => {
    setQuizFeedback(null);
    setQuizStage(0);
  };

  const handleAnswer = (qIdx, key) => {
    const question = QUIZ_QUESTIONS[qIdx];
    const isCorrect = question.correct === "ANY" || key === question.correct;
    if (isCorrect) {
      setQuizFeedback({ ok: true, text: question.feedback });
      setTimeout(() => {
        setQuizFeedback(null);
        if (qIdx < QUIZ_QUESTIONS.length - 1) {
          setQuizStage(qIdx + 1);
        } else {
          setQuizStage("finale");
        }
      }, 1500);
    } else {
      setShake(true);
      setQuizFeedback({ ok: false, text: "Tekrar dene ❤️" });
      setTimeout(() => setShake(false), 600);
      setTimeout(() => setQuizFeedback(null), 1400);
    }
  };

  // typewriter effect on finale
  useEffect(() => {
    if (quizStage !== "finale") return;
    setTypedPoem("");
    let i = 0;
    const id = setInterval(() => {
      i += 1;
      setTypedPoem(QUIZ_POEM.slice(0, i));
      if (i >= QUIZ_POEM.length) clearInterval(id);
    }, 45);
    return () => clearInterval(id);
  }, [quizStage]);

  // ---------- LOVE RPG ----------
  const openRpg = () => {
    setRpgStage("intro");
    setLoveMeter(50);
    setSecretOpen(false);
    setTypedSecret("");
  };
  const closeRpg = () => {
    setRpgStage("closed");
    setSecretOpen(false);
    setTypedSecret("");
  };
  const startRpg = () => setRpgStage(0);

  const pickChoice = (sceneIdx, choice) => {
    setLoveMeter((v) => Math.max(0, Math.min(100, v + choice.love)));
    setTimeout(() => {
      if (sceneIdx < LOVE_RPG_SCENES.length - 1) {
        setRpgStage(sceneIdx + 1);
      } else {
        setRpgStage("glitch");
        setTimeout(() => setRpgStage("final"), 2600);
      }
    }, 700);
  };

  // animate love % in final
  useEffect(() => {
    if (rpgStage !== "final") return;
    setAnimatedLove(0);
    let v = 0;
    const target = loveMeter;
    const id = setInterval(() => {
      v += 1;
      setAnimatedLove(v);
      if (v >= target) clearInterval(id);
    }, 28);
    return () => clearInterval(id);
  }, [rpgStage, loveMeter]);

  // typewriter for secret message
  useEffect(() => {
    if (!secretOpen) return;
    setTypedSecret("");
    let i = 0;
    const id = setInterval(() => {
      i += 1;
      setTypedSecret(SECRET_MESSAGE.slice(0, i));
      if (i >= SECRET_MESSAGE.length) clearInterval(id);
    }, 35);
    return () => clearInterval(id);
  }, [secretOpen]);

  useEffect(() => {
    document.title = "enesinseheri";
  }, []);

  return (
    <div className="love-wrap" ref={containerRef} data-testid="love-page">
      <Toaster position="top-center" richColors />

      {/* soft background orbs */}
      <div className="orb orb-a" aria-hidden="true" />
      <div className="orb orb-b" aria-hidden="true" />
      <div className="orb orb-c" aria-hidden="true" />
      <div className="grain" aria-hidden="true" />

      <header className="love-header" data-testid="love-header">
        <div className="brand">
          <Heart fill="#e85a7a" strokeWidth={0} size={18} />
          <span>for Seher</span>
        </div>
        <nav className="nav-actions">
          <button
            type="button"
            className="nav-btn nav-btn-rose"
            onClick={openRpg}
            data-testid="rpg-open"
          >
            <BookHeart size={16} />
            Çok sevmezsen ölerim
          </button>
          <button
            type="button"
            className="nav-btn nav-btn-primary"
            onClick={openQuiz}
            data-testid="quiz-open"
          >
            <Sparkles size={16} />
            Quiz <span className="nav-btn-heart">💖</span>
          </button>
        </nav>
      </header>

      {!answered ? (
        <main className="stage" data-testid="question-stage">
          <div className="hearts-bg ambient" aria-hidden="true">
            {Array.from({ length: 8 }).map((_, i) => (
              <Floater
                key={i}
                delay={(i * 1.4) % 8}
                left={(i * 41) % 100}
                size={10 + ((i * 5) % 14)}
                duration={11 + ((i * 4) % 7)}
              />
            ))}
          </div>

          {/* Cute decorations: Hello Kitty + flowers */}
          <span className="deco kitty-tl" aria-hidden="true">
            <HelloKitty size={68} />
          </span>
          <span className="deco kitty-br" aria-hidden="true">
            <HelloKitty size={52} />
          </span>
          <span className="deco bloom b1" aria-hidden="true">
            <Blossom size={28} color="#f7c8d1" />
          </span>
          <span className="deco bloom b2" aria-hidden="true">
            <Blossom size={20} color="#fcdce3" />
          </span>
          <span className="deco bloom b3" aria-hidden="true">
            <Blossom size={32} color="#ffd4a8" center="#e85a7a" />
          </span>
          <span className="deco bloom b4" aria-hidden="true">
            <Blossom size={22} color="#f7c8d1" />
          </span>
          <span className="deco bloom b5" aria-hidden="true">
            <Blossom size={18} color="#fcdce3" />
          </span>

          <p className="welcome-line">hoş geldin, Seher</p>
          <p className="eyebrow">sana özel bir soru</p>
          <h1 className="title" data-testid="main-title">
            Beni seviyor musun?
          </h1>
          <div className="title-flourish" aria-hidden="true">
            <span />
            <Heart size={12} fill="#e85a7a" strokeWidth={0} />
            <span />
          </div>
          <p className="subtitle">
            <span className="script">{RECIPIENT}</span>, kalbim cevabını bekliyor…
          </p>

          <div className="actions">
            <button
              type="button"
              onClick={handleYes}
              className="btn btn-yes"
              data-testid="yes-button"
            >
              <Heart size={18} fill="currentColor" strokeWidth={0} />
              Evet
            </button>

            <button
              type="button"
              onClick={moveNoButton}
              onMouseEnter={moveNoButton}
              onTouchStart={moveNoButton}
              onFocus={moveNoButton}
              className="btn btn-no"
              style={{
                transform: `translate(${noPos.x}px, ${noPos.y}px)`,
              }}
              data-testid="no-button"
            >
              {noClicks > 0
                ? NO_TEASES[(noClicks - 1) % NO_TEASES.length]
                : "Hayır"}
            </button>
          </div>

          {noClicks > 3 && (
            <p className="hint" data-testid="no-hint">
              ipucu: "Evet" tam orada, yanında 💗
            </p>
          )}

          {/* Ne Zamandır Birbirimiziz — toggle */}
          <div className="together-block">
            <button
              type="button"
              className={`together-toggle ${showTimer ? "is-open" : ""}`}
              onClick={() => setShowTimer((s) => !s)}
              data-testid="together-toggle"
            >
              <Clock size={16} />
              Ne Zamandır Birbirimize Sahibiz &lt;3
            </button>

            {showTimer && (
              <div className="together-card" data-testid="together-card">
                <p className="together-eyebrow">
                  28 Ağustos 2025'ten beri · {parts.totalDays} gündür seninim
                </p>
                <div className="together-grid">
                  <div className="t-cell">
                    <span className="t-num" data-testid="t-months">{parts.months}</span>
                    <span className="t-lbl">ay</span>
                  </div>
                  <div className="t-cell">
                    <span className="t-num" data-testid="t-weeks">{parts.weeks}</span>
                    <span className="t-lbl">hafta</span>
                  </div>
                  <div className="t-cell">
                    <span className="t-num" data-testid="t-days">{parts.days}</span>
                    <span className="t-lbl">gün</span>
                  </div>
                  <div className="t-cell">
                    <span className="t-num" data-testid="t-hours">
                      {String(parts.hours).padStart(2, "0")}
                    </span>
                    <span className="t-lbl">saat</span>
                  </div>
                  <div className="t-cell small">
                    <span className="t-num" data-testid="t-minutes">
                      {String(parts.minutes).padStart(2, "0")}
                    </span>
                    <span className="t-lbl">dk</span>
                  </div>
                  <div className="t-cell small">
                    <span className="t-num pulse" data-testid="t-seconds">
                      {String(parts.seconds).padStart(2, "0")}
                    </span>
                    <span className="t-lbl">sn</span>
                  </div>
                </div>
                <p className="together-foot">ve her saniye daha çok seviyorum seni</p>
              </div>
            )}
          </div>

          {/* Fotiklerr <3 — tüm fotoğraflar romantik posterler olarak */}
          <section className="extras" data-testid="extras">
            <button
              type="button"
              className={`extras-toggle ${showExtras ? "is-open" : ""}`}
              onClick={() => setShowExtras((s) => !s)}
              data-testid="extras-toggle"
            >
              <Camera size={16} />
              Fotiklerr <Heart size={14} fill="currentColor" strokeWidth={0} />
            </button>

            {showExtras && (
              <div className="posters" data-testid="posters">
                {PHOTOS.map((p, i) => (
                  <article
                    key={p.src}
                    className="poster"
                    data-testid={`poster-${i}`}
                  >
                    <div
                      className="poster-frame"
                      onClick={() => openPhoto(i)}
                      role="button"
                      tabIndex={0}
                    >
                      <img src={p.src} alt={p.title} loading="lazy" />
                      <span className="poster-corner">
                        <Heart size={14} fill="#fff" strokeWidth={0} />
                      </span>
                    </div>
                    <div className="poster-body">
                      <h4 className="poster-title">{p.title}</h4>
                      <p className="poster-quote">"{p.quote}"</p>
                      <p className="poster-sign">— Enes'inden Seher'e</p>
                    </div>
                  </article>
                ))}
              </div>
            )}
          </section>
        </main>
      ) : (
        <main className="stage answered" data-testid="answer-stage">
          <div className="hearts-bg" aria-hidden="true">
            {Array.from({ length: 18 }).map((_, i) => (
              <Floater
                key={i}
                delay={(i * 0.35) % 5}
                left={(i * 53) % 100}
                size={14 + ((i * 7) % 22)}
                duration={5 + ((i * 3) % 6)}
              />
            ))}
          </div>

          <div className="reveal" data-testid="love-reveal">
            <div className="big-heart">
              <Heart fill="#e85a7a" strokeWidth={0} />
            </div>
            <h2 className="reveal-title">Ben de seni seviyorum</h2>
            <p className="reveal-note" data-testid="love-message">
              {LOVE_MESSAGE.split("\n").map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
            </p>
            <p className="signed">— sonsuza kadar</p>

            <div className="share-row">
              <button
                type="button"
                onClick={shareWhatsApp}
                className="chip chip-green"
                data-testid="share-whatsapp"
              >
                <Share2 size={16} />
                WhatsApp
              </button>
              <button
                type="button"
                onClick={copyLink}
                className="chip"
                data-testid="copy-link"
              >
                <Copy size={16} />
                Bağlantıyı kopyala
              </button>
              <button
                type="button"
                onClick={nativeShare}
                className="chip"
                data-testid="native-share"
              >
                <Share2 size={16} />
                Paylaş
              </button>
              <button
                type="button"
                onClick={reset}
                className="chip chip-ghost"
                data-testid="reset-button"
              >
                <RotateCcw size={16} />
                Baştan
              </button>
            </div>
          </div>
        </main>
      )}

      <footer className="love-footer">
        <span>sadece ikimiz için · {new Date().getFullYear()}</span>
      </footer>

      {/* QUIZ OVERLAY */}
      {quizStage !== "closed" && (
        <div className="quiz-overlay" data-testid="quiz-overlay">
          {/* YouTube background music — hidden iframe */}
          {musicOn && (
            <iframe
              title="quiz-music"
              src="https://www.youtube.com/embed/RsnjAxL2jSo?autoplay=1&loop=1&playlist=RsnjAxL2jSo&controls=0&modestbranding=1&rel=0&playsinline=1"
              allow="autoplay; encrypted-media"
              style={{
                position: "absolute",
                width: "1px",
                height: "1px",
                opacity: 0,
                pointerEvents: "none",
                border: 0,
              }}
            />
          )}

          <div className="quiz-bg" aria-hidden="true">
            <div className="quiz-orb a" />
            <div className="quiz-orb b" />
            <div className="quiz-orb c" />
          </div>

          <button
            type="button"
            className="quiz-music"
            onClick={() => setMusicOn((m) => !m)}
            aria-label={musicOn ? "Müziği kapat" : "Müziği aç"}
            data-testid="quiz-music-toggle"
          >
            {musicOn ? <Volume2 size={18} /> : <VolumeX size={18} />}
          </button>

          <button
            type="button"
            className="quiz-close"
            onClick={closeQuiz}
            aria-label="Kapat"
            data-testid="quiz-close"
          >
            <X size={20} />
          </button>

          {/* INTRO */}
          {quizStage === "intro" && (
            <div className="quiz-stage quiz-intro" data-testid="quiz-intro">
              <p className="quiz-eyebrow">küçük bir aşk oyunu</p>
              <h2 className="quiz-title">
                QUIZZ <span className="quiz-title-heart">💖</span>
              </h2>
              <p className="quiz-lead">
                Üç küçük soru, bir büyük cevap.
                <br />
                Hazır mısın aşkım?
              </p>
              <button
                type="button"
                className="quiz-start"
                onClick={startQuiz}
                data-testid="quiz-start"
              >
                <Sparkles size={18} />
                Quiz'i Başlat
              </button>
            </div>
          )}

          {/* QUESTIONS */}
          {typeof quizStage === "number" && (
            <div
              className={`quiz-stage quiz-question-stage ${shake ? "is-shake" : ""}`}
              data-testid={`quiz-q${quizStage + 1}`}
            >
              <div className="quiz-progress">
                {QUIZ_QUESTIONS.map((_, i) => (
                  <span
                    key={i}
                    className={`dot ${i === quizStage ? "is-active" : ""} ${i < quizStage ? "is-done" : ""}`}
                  />
                ))}
              </div>

              <p className="quiz-eyebrow">
                Soru {quizStage + 1} / {QUIZ_QUESTIONS.length}
              </p>

              <h3 className="quiz-q">{QUIZ_QUESTIONS[quizStage].q}</h3>

              <div className="quiz-options">
                {QUIZ_QUESTIONS[quizStage].options.map((opt) => (
                  <button
                    key={opt.key}
                    type="button"
                    className="quiz-option"
                    onClick={() => handleAnswer(quizStage, opt.key)}
                    disabled={!!quizFeedback}
                    data-testid={`quiz-option-${opt.key}`}
                  >
                    <span className="quiz-option-key">{opt.key}</span>
                    <span className="quiz-option-text">{opt.text}</span>
                  </button>
                ))}
              </div>

              {quizFeedback && (
                <div
                  className={`quiz-fb ${quizFeedback.ok ? "ok" : "no"}`}
                  data-testid="quiz-feedback"
                >
                  {quizFeedback.ok && (
                    <Heart size={16} fill="currentColor" strokeWidth={0} />
                  )}
                  <span>{quizFeedback.text}</span>
                </div>
              )}
            </div>
          )}

          {/* FINALE */}
          {quizStage === "finale" && (
            <div className="quiz-stage quiz-finale" data-testid="quiz-finale">
              <div className="heart-rain" aria-hidden="true">
                {Array.from({ length: 28 }).map((_, i) => (
                  <span
                    key={i}
                    className="rain-heart"
                    style={{
                      left: `${(i * 37) % 100}%`,
                      animationDelay: `${(i * 0.27) % 6}s`,
                      animationDuration: `${6 + ((i * 5) % 8)}s`,
                      fontSize: `${14 + ((i * 11) % 22)}px`,
                    }}
                  >
                    <Heart fill="#e85a7a" strokeWidth={0} />
                  </span>
                ))}
              </div>

              <div className="finale-inner">
                <div className="finale-heart">
                  <Heart fill="#e85a7a" strokeWidth={0} />
                </div>
                <h2 className="finale-title">Seni seçtim... 💖</h2>
                <p className="finale-sub">
                  28 Ağustos 2025'ten beri · {parts.totalDays} gündür seninim
                </p>
                <pre className="finale-poem" data-testid="finale-poem">
                  {typedPoem}
                  <span className="caret" />
                </pre>
                <p className="finale-glow">
                  ve seni seçmeye sonsuza kadar devam edeceğim, Seher.
                </p>
                <div className="finale-actions">
                  <button
                    type="button"
                    className="quiz-start"
                    onClick={() => setQuizStage("intro")}
                    data-testid="quiz-restart"
                  >
                    <RotateCcw size={16} />
                    Tekrar oyna
                  </button>
                  <button
                    type="button"
                    className="quiz-secondary"
                    onClick={closeQuiz}
                    data-testid="quiz-back-home"
                  >
                    Sayfaya dön
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* LOVE RPG OVERLAY */}
      {rpgStage !== "closed" && (
        <div
          className={`rpg-overlay ${rpgStage === "glitch" ? "is-glitch" : ""}`}
          data-testid="rpg-overlay"
        >
          <div className="rpg-bg" aria-hidden="true">
            <div className="rpg-orb a" />
            <div className="rpg-orb b" />
            <div className="rpg-orb c" />
          </div>

          {rpgStage !== "glitch" && (
            <button
              type="button"
              className="quiz-close"
              onClick={closeRpg}
              aria-label="Kapat"
              data-testid="rpg-close"
            >
              <X size={20} />
            </button>
          )}

          {(typeof rpgStage === "number" || rpgStage === "intro") && (
            <div className="love-meter" data-testid="love-meter">
              <div className="meter-label">
                <Heart size={14} fill="#ff6f95" strokeWidth={0} />
                <span>Aşk Ölçer</span>
                <strong>{loveMeter}%</strong>
              </div>
              <div className="meter-track">
                <div className="meter-fill" style={{ width: `${loveMeter}%` }} />
              </div>
            </div>
          )}

          {rpgStage === "intro" && (
            <div className="quiz-stage rpg-intro" data-testid="rpg-intro">
              <p className="quiz-eyebrow">interaktif aşk hikayesi</p>
              <h2 className="quiz-title rpg-name">
                Çok sevmezsen ölerim
                <span className="quiz-title-heart">💕</span>
              </h2>
              <p className="quiz-lead">
                On küçük sahne, on büyük seçim.
                <br />
                Hazır mısın bizim hikayemizi yeniden yaşamaya?
              </p>
              <button
                type="button"
                className="quiz-start"
                onClick={startRpg}
                data-testid="rpg-start"
              >
                <Sparkles size={18} />
                Başla
              </button>
            </div>
          )}

          {typeof rpgStage === "number" && (
            <div className="quiz-stage rpg-scene" data-testid={`rpg-scene-${rpgStage}`}>
              <div className="quiz-progress">
                {LOVE_RPG_SCENES.map((_, i) => (
                  <span
                    key={i}
                    className={`dot ${i === rpgStage ? "is-active" : ""} ${i < rpgStage ? "is-done" : ""}`}
                  />
                ))}
              </div>
              <p className="quiz-eyebrow">
                Sahne {rpgStage + 1} / {LOVE_RPG_SCENES.length} ·{" "}
                {LOVE_RPG_SCENES[rpgStage].title}
              </p>
              <p className="rpg-text">{LOVE_RPG_SCENES[rpgStage].text}</p>
              <div className="rpg-choices">
                {LOVE_RPG_SCENES[rpgStage].choices.map((c, i) => (
                  <button
                    key={i}
                    type="button"
                    className="rpg-choice"
                    onClick={() => pickChoice(rpgStage, c)}
                    data-testid={`rpg-choice-${rpgStage}-${i}`}
                  >
                    <span className="rpg-choice-text">{c.text}</span>
                    <span className={`rpg-choice-love ${c.love < 0 ? "neg" : ""}`}>
                      {c.love > 0 ? `+${c.love}` : c.love}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          )}

          {rpgStage === "glitch" && (
            <div className="rpg-glitch" data-testid="rpg-glitch">
              <div className="glitch-text" data-text="Sistem çöküyor...">
                Sistem çöküyor...
              </div>
              <div className="glitch-scan" />
            </div>
          )}

          {rpgStage === "final" && (() => {
            const tier =
              loveMeter >= 80 ? "good" : loveMeter >= 45 ? "neutral" : "bad";
            const titles = {
              good: "Sonsuza dek seninim 💍",
              neutral: "Aslında hiçbir şey bozulmadı… sadece seni daha çok sevdim 💖",
              bad: "Belki başka bir hayatta yine bulurduk birbirimizi… 🥀",
            };
            const subs = {
              good: "Kalbin kalbimle aynı ritimde atıyor. Bu hikâye bizimle bitmez, bizimle başlar.",
              neutral: "Yolumuz uzun, ama her adım seninle güzel. Sana inanıyorum, bize inanıyorum.",
              bad: "Belki bazı seçimlerimiz kalbimi titretmedi… Ama yine de seçimim hep sen olacaksın. Bir şans daha?",
            };
            const tags = {
              good: "Sonsuz Bağ",
              neutral: "Sıcak Bir Ümit",
              bad: "Uzak Bir Hayal",
            };
            return (
              <div
                className={`quiz-stage rpg-final tier-${tier}`}
                data-testid={`rpg-final-${tier}`}
              >
                <div className="heart-rain" aria-hidden="true">
                  {Array.from({ length: tier === "bad" ? 14 : 32 }).map((_, i) => (
                    <span
                      key={i}
                      className="rain-heart"
                      style={{
                        left: `${(i * 31) % 100}%`,
                        animationDelay: `${(i * 0.23) % 6}s`,
                        animationDuration: `${
                          (tier === "bad" ? 9 : 6) + ((i * 5) % 8)
                        }s`,
                        fontSize: `${14 + ((i * 11) % 22)}px`,
                      }}
                    >
                      <Heart fill={tier === "bad" ? "#a07a82" : "#ff6f95"} strokeWidth={0} />
                    </span>
                  ))}
                </div>
                <div className="finale-inner">
                  <div className="finale-heart">
                    <Heart fill={tier === "bad" ? "#9c4f5e" : "#e85a7a"} strokeWidth={0} />
                  </div>
                  <h2 className="finale-title">{titles[tier]}</h2>
                  <div className={`final-love-ring ring-${tier}`}>
                    <span className="final-love-num">{animatedLove}%</span>
                    <span className="final-love-lbl">Sevgi</span>
                  </div>
                  <p className="finale-glow">
                    {tags[tier]}{" "}
                    <span style={{ fontSize: "1.2em" }}>
                      {tier === "good" ? "💍" : tier === "neutral" ? "🌹" : "🥀"}
                    </span>
                  </p>
                  <p className="rpg-final-sub">{subs[tier]}</p>
                  <div className="finale-actions">
                    <button
                      type="button"
                      className="quiz-start"
                      onClick={openRpg}
                      data-testid="rpg-restart"
                    >
                      <RotateCcw size={16} />
                      {tier === "bad" ? "Bir şans daha" : "Tekrar oyna"}
                    </button>
                    <button
                      type="button"
                      className="quiz-secondary"
                      onClick={closeRpg}
                      data-testid="rpg-back-home"
                    >
                      Sayfaya dön
                    </button>
                  </div>
                </div>
              </div>
            );
          })()}

          {loveMeter > 70 && rpgStage !== "glitch" && (
            <button
              type="button"
              className="secret-fab"
              onClick={() => setSecretOpen(true)}
              data-testid="secret-open"
            >
              <Mail size={16} />
              Secret Message <Heart size={12} fill="currentColor" strokeWidth={0} />
            </button>
          )}

          {secretOpen && (
            <div
              className="secret-modal"
              onClick={() => setSecretOpen(false)}
              data-testid="secret-modal"
            >
              <div className="secret-card" onClick={(e) => e.stopPropagation()}>
                <div className="secret-seal">
                  <Mail size={18} />
                </div>
                <h3 className="secret-title">Sana özel...</h3>
                <pre className="secret-text" data-testid="secret-text">
                  {typedSecret}
                  <span className="caret" />
                </pre>
                <button
                  type="button"
                  className="quiz-secondary"
                  onClick={() => setSecretOpen(false)}
                >
                  Kapat
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {lightboxIdx !== null && (
        <div
          className="lightbox"
          onClick={closePhoto}
          data-testid="lightbox"
          role="dialog"
          aria-modal="true"
        >
          <button
            type="button"
            className="lb-btn lb-close"
            onClick={closePhoto}
            aria-label="Kapat"
            data-testid="lightbox-close"
          >
            <X size={22} />
          </button>
          <button
            type="button"
            className="lb-btn lb-prev"
            onClick={prevPhoto}
            aria-label="Önceki"
          >
            <ChevronLeft size={26} />
          </button>
          <figure className="lb-figure" onClick={(e) => e.stopPropagation()}>
            <img src={PHOTOS[lightboxIdx].src} alt={PHOTOS[lightboxIdx].title} />
            <figcaption>{PHOTOS[lightboxIdx].title}</figcaption>
          </figure>
          <button
            type="button"
            className="lb-btn lb-next"
            onClick={nextPhoto}
            aria-label="Sonraki"
          >
            <ChevronRight size={26} />
          </button>
        </div>
      )}
    </div>
  );
};

function App() {
  return <LovePage />;
}

export default App;
